import React from "react";

export default function ManagementIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.08 0.06C9.9 0.06 9.78 0 9.6 0V9C9.6 9.3 9.3 9.6 9 9.6H0C0 9.78 0 9.9 0.06 10.08C0.6 14.52 4.38 18 9 18C13.98 18 18 13.98 18 9C18 4.38 14.52 0.6 10.08 0.06Z"
                fill="#4F6E90"/>
            <path d="M1.8 8.4H8.4V0C8.22 0 8.1 0 7.92 0.06C3.84 0.54 0.54 3.84 0.06 7.92C0.06 8.1 0 8.22 0 8.4H1.8Z"
                  fill="#354F6C"/>
        </svg>

    );
}
